import { Observable, Subscriber } from 'rxjs';
import { debounceTime, finalize, tap } from 'rxjs/operators';

/**
 * An observable creator for element resize.
 *
 * @param elm the watch element.
 * @param cb when resize complete, call back function.
 * @param time resize emit time, default is 200
 */
export function resizeObservable(elm: HTMLElement, cb: (entry: ResizeObserverEntry) => void, time = 200): Observable<ResizeObserverEntry> {
    let elmObserve$: ResizeObserver;

    let observable = new Observable((observer: Subscriber<ResizeObserverEntry>) => {
        if (typeof window !== 'undefined') {
            elmObserve$ = new ResizeObserver(e => observer.next(e[0]));

            if (elm !== null) {
                elmObserve$.observe(elm);
            }
        }
    });
    if (time) {
        observable = observable.pipe(debounceTime(time));
    }
    return observable.pipe(
        tap(e => cb(e)),
        finalize(() => {
            if (elmObserve$) {
                elmObserve$.unobserve(elm);
                elmObserve$.disconnect();
            }
        })
    );
}
